import { PublicFAQ } from './publicFAQ'

export { PublicFAQ }
